import { render } from "./FaenasCliente.vue?vue&type=template&id=de7fe9ca"
import script from "./FaenasCliente.vue?vue&type=script&lang=js"
export * from "./FaenasCliente.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__